import { useMemo } from "react";
import { CatalogEntityType, resolveAggregatedType } from "../types";
import { ActivityV1Type } from "../AddActivity/types";

export interface NormalizedAggregatedItem {
  entity: any;
  entityType: CatalogEntityType;
  activityType?: ActivityV1Type;
  isDraft: boolean;
}

export const useNormalizedAggregatedItems = (
  items: any[] | undefined,
): NormalizedAggregatedItem[] =>
  useMemo(
    () =>
      (items || []).map((raw: any) => {
        const { entityType, activityType } = resolveAggregatedType(raw.type);
        return {
          entity: raw.lo,
          entityType,
          activityType,
          isDraft: !!raw.draft,
        };
      }),
    [items],
  );
